import { OverviewPage } from "./OverviewPage";

import { HomeIcon } from "@/components/icons";
import { ROUTES } from "@/config/routes";
import type { FeatureModule } from "@/types/feature";

/** Overview feature registration. This is the public surface of the feature. */
export const overviewFeature: FeatureModule = {
  id: "overview",
  navItems: [
    {
      id: "overview",
      label: "Home",
      path: ROUTES.overview,
      icon: HomeIcon,
    },
  ],
  routes: [{ index: true, element: <OverviewPage /> }],
};
